export const PAGE_SIZE = 25

export const ACTIVITY_TYPES = [
  'stamps_added',
  'stamp_correction',
  'reward_unlocked',
  'reward_redeemed',
  'reward_restored',
  'referral_bonus',
  'reward_expired',
  'new_member_joined',
  'birthday_reward_unlocked',
] as const

export type ActivityType = (typeof ACTIVITY_TYPES)[number]

export interface RecentActivityEntry {
  id: string
  type: ActivityType
  stampsDelta: number
  rewardsDelta: number
  createdAt: string
  actorName: string | null
  actorRole: string | null
  memberName: string
  memberEmail: string
  memberId: string
  memberDisplayId: string | null
  receiptId: string | null
  correctionReason: string | null
  correctionNote: string | null
  rewardItemName: string | null
  earningMethod: string | null
  amountPerStamp: number | null
  deviceName: string | null
  trigger: string | null
  stampTargetBefore: number | null
  stampTargetAfter: number | null
  stampsBeforeReduction: number | null
  stampsAfterReduction: number | null
}
